// 文件路径: src/data/comments.js

export const COMMENT_POOL = {
  ai: [
    { author: "架构师_张三", text: "AI 只是工具，不会替代人，替代你的是会用 AI 的人（狗头保命）。", color: "#ff9800" },
    { author: "赛博念经人", text: "这不就是套了个壳吗？我上我也行。", color: "#9c27b0" },
    { author: "算法老王", text: "算力不够，这模型跑起来得卡成 PPT 吧？", color: "#00bcd4" },
    { author: "AGI信徒", text: "碳基生物的终点到了，赞美硅基神明！", color: "#e91e63" }
  ],
  layoff: [
    { author: "前排HR", text: "其实这不是裁员，这叫向社会输送优秀人才。", color: "#f44336" },
    { author: "背锅侠", text: "系统刚重构完就把我踢了，真是卸磨杀驴啊...", color: "#795548" },
    { author: "脉脉潜水员", text: "听说隔壁组整个端了，N+1 给了没？", color: "#ffeb3b" },
    { author: "灵活就业者", text: "兄弟们别怕，外卖站招人，我昨天刚提了电动车。", color: "#607d8b" }
  ],
  capital: [
    { author: "韭菜本菜", text: "昨天刚满仓买入，今天就出这新闻？退钱！", color: "#4caf50" },
    { author: "理智分析师", text: "这波是资本在洗盘，大家拿住，家人们不要慌！", color: "#03a9f4" },
    { author: "VC合伙人", text: "PPT 讲得不错，下次估值再翻十倍我投一点。", color: "#ff5722" }
  ],
  general: [
    { author: "匿名码农", text: "世界草台班子，马上就要崩盘了赶紧跑路。", color: "#8bc34a" },
    { author: "吃瓜群众", text: "坐等反转，先插个眼。", color: "#9e9e9e" },
    { author: "下班第一名", text: "别吵了，到点了，打卡下班！", color: "#cddc39" },
    { author: "需求永动机", text: "产品经理看后连夜加了 10 个需求。", color: "#8d6e63" }
  ]
};

// 导出一个生成函数供外部使用
export const generateCommentsForNews = (title) => {
  let category = 'general';
  if (/(模型|AI|代码|开源|技术|架构|智能)/i.test(title)) category = 'ai';
  else if (/(裁员|毕业|离职|优化|降本|事故|崩溃)/i.test(title)) category = 'layoff';
  else if (/(融资|上市|财报|市值|估值|资本)/i.test(title)) category = 'capital';
  
  const combinedPool = [...COMMENT_POOL[category], ...COMMENT_POOL.general];
  const shuffled = combinedPool.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 2);
};